import server from "./request";
import { getSign } from "./getSign";
import qs from "qs";

const http = {
    // get方法
    get(url, params = {}) {
        const config = {
            method: "get",
            url,
            params: params ? qs.stringfy(params) : "",
            headers: params ? getSign(params) : {},
        };
        return server(config);
    },
    // post 方法
    post(url, data = {}) {
        const config = {
            method: "post",
            url,
            data: data ? data : "",
            headers: data ? getSign(data) : {},
        };
        return server(config);
    },
    // put 方法
    put(url, params = {}) {
        const config = {
            method: "put",
            url,
            params: params ? qs.stringfy(params) : "",
            headers: params ? getSign(params) : {},
        };
        return server(config);
    },
    // delete 方法
    delete(url, params = {}) {
        const config = {
            method: "delete",
            url,
            params: params ? qs.stringfy(params) : "",
            headers: params ? getSign(params) : {},
        };
        return server(config);
    },
};
export default http;
